import _ from "underscore";
export const getProgramsPagePresetNameByClientId = (id) => {
    return `programs_page_presets_for_${id}`;
};
export const getFavoriteProgramsFromResponse = (userPropertyResponse, clientId) => {
    return _.findWhere(userPropertyResponse, {
        name: `favorite_programs_for_${clientId}`,
    });
};
export const getTagsConfigurationsFromResponse = (userPropertyResponse, clientId) => {
    return _.findWhere(userPropertyResponse, {
        name: `tags_configuration_for_${clientId}`,
    });
};
export const getPresetForUser = (clientId, userPropertyResponse) => {
    const name = getProgramsPagePresetNameByClientId(clientId);
    return (_.findWhere(userPropertyResponse, {
        name,
    }) || null);
};
export const serializeFavoriteIntoUserProperty = (update) => {
    const name = `favorite_programs_for_${update.clientId}`;
    const value = JSON.stringify(update.favorites);
    return {
        name,
        value,
    };
};
export const serializeTagsConfigurationsIntoUserProperty = (update) => {
    const name = `tags_configuration_for_${update.clientId}`;
    const value = JSON.stringify(update.tagsConfiguration);
    return {
        name,
        value,
    };
};
export const serializePresetIntoUserProperty = (update) => {
    const name = getProgramsPagePresetNameByClientId(update.clientId);
    const value = JSON.stringify(update.presets);
    return {
        name,
        value,
    };
};
export const parsePresetFromUserProperty = (userProperty) => {
    try {
        return JSON.parse(userProperty.value);
    }
    catch (e) {
        return [];
    }
};
export const parseFavoritesFromUserProperty = (userProperty) => {
    try {
        return JSON.parse(userProperty.value);
    }
    catch (e) {
        return [];
    }
};
export const parseTagsConfigurationsFromUserProperty = (userProperty) => {
    try {
        return JSON.parse(userProperty.value);
    }
    catch (e) {
        return {
            are_visible: false,
        };
    }
};
